export enum AccountStatus {
	Active = 'Active',
	Inactive = 'Inactive',
}
